import React from 'react';
import {CardBody, Typography} from "@material-tailwind/react";
import MapComponent from "../../shared/map_component";

// Panel compartido "Información del predio" para los componentes de movimientos:
// mapa, dirección, referencias, R.P.P. y propietario del predio en observación.
const LotSummary = ({lot}) => {
    if (!lot) return null;

    return (
        <CardBody className='p-0'>
            <div className="w-full mb-4 bg-gray-100">
                {(lot.latitude && lot.longitude) && (
                    <MapComponent
                        parcel_code={lot.parcel_code}
                        latitude={lot.latitude}
                        longitude={lot.longitude}
                    />
                )}
            </div>
            <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                <div className='flex flex-col w-full'>
                    <Typography
                        variant="small"
                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                    >
                        Dirección
                    </Typography>
                    <Typography
                        variant="paragraph"
                        className="font-medium"
                    >
                        {lot.road_name}{lot.ext_num ? " #" + lot.ext_num : ""}, {lot.neighborhood_name},
                        C.P. {lot.postal_code}
                    </Typography>
                </div>
                <div className='flex flex-col w-full'>
                    <Typography
                        variant="small"
                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                    >
                        Referencias
                    </Typography>
                    <Typography
                        variant="paragraph"
                        className="font-medium"
                    >
                        {lot.address_references === null ? '' : lot.address_references}
                    </Typography>
                </div>
            </div>
            <hr className="my-6 border-b-1 border-blue-gray-100"/>
            <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                REGISTRO DEL PREDIO
            </h6>
            <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-0">
                    <div className="relative w-full mb-3">
                        <div className='py-2'>
                            <Typography
                                variant="small"
                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                            >
                                R.P.P.
                            </Typography>
                            <div className='flex flex-row gap-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Insc.
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.inscription}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Folio
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.folio}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Libro
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.book}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="my-6 border-b-1 border-blue-gray-100"/>
            <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                PROPIETARIO
            </h6>
            <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-0">
                    <div className="relative w-full mb-3">
                        <div className='py-2'>
                            {lot.contributor_type === 'P' ? (
                                <div className='flex flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Nombre
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.name}
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Apellido paterno
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.parental_last_name}
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Apellido Materno
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.maternal_last_name}
                                        </Typography>
                                    </div>
                                </div>
                            ) : (
                                <div className='flex flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Razón social
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.name}
                                        </Typography>
                                    </div>
                                </div>
                            )}
                            <div className='flex flex-row gap-4 mt-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Dirección
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.contributor_street}
                                        {lot.contributor_ext_num ? " #" + lot.contributor_ext_num : ""}
                                        {lot.contributor_neighborhood ? ', ' + lot.contributor_neighborhood : ''}
                                        {lot.contributor_postal_code ? ', C.P. ' + lot.contributor_postal_code : ''}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Teléfono
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.phone ? lot.phone : 'N/A'}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        RFC
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.rfc ? lot.rfc : 'N/A'}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CardBody>
    );
};

export default LotSummary;
